import { TYPE_PERMISSION } from 'v2/resources/types/users';
import { IFormikValues, IPermission } from './types';

export const enum USER_TYPE {
  PF = 'pf',
  PJ = 'pj',
}

export const initialValues: IFormikValues = {
  name: '',
  cpfCnpj: '',
  cellphone: '',
  email: '',
  function: '',
  nature: USER_TYPE.PF,
  active: false,
  permissions: {
    performance: [],
    production: [],
    reports: [],
    purchases: [],
    finance: [],
    commercial: [],
    employees: [],
  },
};

export const listPermissions: Array<IPermission> = [
  {
    value: TYPE_PERMISSION.PERFORMANCE,
    label: 'Desempenho (gráficos)',
    items: [
      {
        value: 'water_analysis_chart',
        label: 'Análise da Água por Viveiros',
      },
      {
        value: 'biometry_by_pond_chart',
        label: 'Biometria por Viveiros',
      },
      {
        value: 'biometry_by_parameter_chart',
        label: 'Biometria por Parâmetros',
      },
      {
        value: 'water_quality_by_parameter_chart',
        label: 'Qualidade da Água por Parâmetros',
      },
      { value: 'health_analysis_chart', label: 'Análise de Saúde' },
      {
        value: 'mortality_by_pond_chart',
        label: 'Mortalidade por Viveiros',
      },
      {
        value: 'inputs_by_pond_chart',
        label: 'Insumos por Viveiros',
      },
    ],
  },
  {
    value: TYPE_PERMISSION.PRODUCTION,
    label: 'Produção',
    items: [
      { value: 'physical_ponds', label: 'Viveiros físicos' },
      { value: 'inputs', label: 'Insumos' },
      { value: 'pond_by_cycle', label: 'Viveiro por ciclo' },
      { value: 'harvest', label: 'Despesca' },
      { value: 'measurements', label: 'Medições' },
      { value: 'shipments', label: 'Remessas' },
      { value: 'unit_of_measure', label: 'Unidade de medida' },
      { value: 'stocking', label: 'Povoamento' },
      { value: 'transfer', label: 'Transferencia' },
      { value: 'consumption', label: 'Consumo' },
      { value: 'mortality', label: 'Mortalidade' },
      { value: 'inventory', label: 'Estoque' },
      { value: 'parameters', label: 'Parâmetros' },
      { value: 'forms', label: 'Formulários' },
    ],
  },
  {
    value: TYPE_PERMISSION.REPORTS,
    label: 'Relatórios',
    items: [
      { value: 'consumption_report', label: 'Relatório de consumo' },
      { value: 'production_report', label: 'Relatório de produção' },
      { value: 'expense_report', label: 'Relatório de gastos' },
    ],
  },
  {
    value: TYPE_PERMISSION.PURSCHASES,
    label: 'Compras',
    items: [
      { value: 'list_purchases', label: 'Listar compras' },
      { value: 'suppliers', label: 'Fornecedores' },
    ],
  },
  {
    value: TYPE_PERMISSION.FINANCE,
    label: 'Financeiro',
    items: [
      { value: 'accounts_payable', label: 'Contas a pagar' },
      { value: 'accounts_receivable', label: 'Contas a receber' },
      { value: 'account_control', label: 'Controle de contas' },
      { value: 'cash_flow', label: 'Fluxo de caixa' },
      { value: 'cost_center', label: 'Centro de custo' },
      { value: 'cost', label: 'Custo' },
    ],
  },
  {
    value: TYPE_PERMISSION.COMERCIAL,
    label: 'Comercial',
    items: [
      { value: 'sales', label: 'Vendas' },
      { value: 'clients', label: 'Clientes' },
      { value: 'account_center', label: 'Central de Contas' },
      { value: 'list_users', label: 'Listar usuários' },
    ],
  },
  {
    value: TYPE_PERMISSION.EMPLOYEES,
    label: 'Funcionários',
    items: [
      { value: 'sales', label: 'Vendas' },
      { value: 'clients', label: 'Clientes' },
      { value: 'account_center', label: 'Central de Contas' },
      { value: 'list_users', label: 'Listar usuários' },
    ],
  },
];

export const optionsNature = [
  {
    id: 1,
    label: 'Pessoa física',
    value: USER_TYPE.PF,
  },
  {
    id: 2,
    label: 'Pessoa Juridica',
    value: USER_TYPE.PJ,
  },
];
